import { render, staticRenderFns } from "./AddItemToBasketOverlay.vue?vue&type=template&id=291fedec&"
import script from "./AddItemToBasketOverlay.vue?vue&type=script&lang=js&"
export * from "./AddItemToBasketOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports